import { Box, Typography, Grid, Stack } from "@mui/material";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import React from "react";
import theme from "../theme/theme";

interface Props {
  image?: string;
  leftComponent?: any;
  onSubmit: any;
  imageStyle?: React.CSSProperties;
}

const AuthLayout: React.FC<Props> = ({
  image = "signin",
  leftComponent,
  onSubmit,
  imageStyle,
}) => {
  const [bgImage, setBgImage] = React.useState(image);

  return (
    <Box sx={{ backgroundColor: "white", maxHeight: "100vh" }} pt={0} mt={0}>
      <Grid container rowSpacing={1}>
        <Grid
          item
          xs={12}
          md={6}
          lg={6}
          style={{
            justifyContent: "center",
            display: "flex",
            maxHeight: "100vh",
            overflow: "auto",
          }}
        >
          <img
              src={require(`../assets/images/login_footer.png`)}
              alt={"item.title"}
              loading="lazy"
              style={{ width: 250, height: 250, position: "absolute", bottom: 0, left: 0}}
            />
          <form onSubmit={onSubmit}>{leftComponent}</form>
        </Grid>

        <Grid
          item
          lg={6}
          md={6}
          sx={{
            justifyContent: "right",
            display: { xs: "none", md: "flex", lg: "flex" },
          }}
        >
          <Box
            sx={{
              position: "relative",
              alignItems: "center",
              display: "flex",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <img
              src={require(`../assets/images/${bgImage}.png`)}
              alt={"logo"}
              loading="lazy"
              style={{ width: "100%", height: "100vh", objectFit: "cover" }}
            />
            <Box
              sx={{ position: "absolute", left: 50, top: 100, width: 600 }}
            >
              <Typography color={theme.colors.secondary} fontSize={24}>
                Lorem ipsum
              </Typography>
              <Typography color="white" fontSize={24} mb={3}>
                2023
              </Typography>

              <Timeline
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot sx={{ mb: 0, ml: 0, pl: 0 }} />
                    <TimelineConnector sx={{ mb: 0, ml: 0, pl: 0 }} />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Stack pb={5}>
                      <Typography color="white" fontSize={24}>
                        09 Février
                      </Typography>
                      <Typography color="whitesmoke" fontSize={14}>
                        At vero eos et accusamus et iusto odio dignissimos
                        ducimus qui blanditiis praesentium voluptatum deleniti
                        atque corrupti quos dolores et quas molestias excepturi
                        sint occaecati cupiditate non provident.
                      </Typography>
                    </Stack>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot sx={{ mt: 0 }} />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Stack>
                      <Typography color="white" fontSize={24}>
                        10 Février
                      </Typography>
                    </Stack>
                  </TimelineContent>
                </TimelineItem>
              </Timeline>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuthLayout;
